<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="bk-title">A Sicilian Romance</p>
<p class="authorname">Ann Radcliffe</p>
<p class="publisher"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled2.vue?0636e9fc